import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIllustration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 117 234"
    {...props}
  >
    <path
      fill="url(#Illustration_svg__a)"
      d="M117 233.997 95.277 103.652C108.427 92.926 117 76.795 117 58.5 117 26.19 90.81 0 58.5 0S0 26.19 0 58.5c0 18.295 8.573 34.426 21.723 45.152L0 233.997h117Z"
    />
    <defs>
      <linearGradient
        id="Illustration_svg__a"
        x1={0}
        x2={317.177}
        y1={233.997}
        y2={83.654}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C4CEF9" />
        <stop offset={0.818} stopColor="#7D81C3" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgIllustration;
